/**
 * The current version, in semver.
 * @type {String}
 */
export const VERSION = "0.9.8";
